export default __webpack_public_path__ + "static/Sanofi-59be39af3dc96f673ecfaf2ce2768c0d.jpg";